import { motion } from "motion/react";

import { Spinner } from "@up/ui";

import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  isSubmitting: boolean;
  [x: PropertyKey]: unknown;
};

export const SubmitButton = function SubmitButton(props: Props) {
  const { children, isSubmitting, ...rest } = props;

  return (
    <button
      className="checkout-submit-button overflow-hidden relative w-full disabled:cursor-not-allowed disabled:opacity-75"
      type="submit"
      {...rest}
    >
      <motion.span
        initial={false}
        animate={{
          y: isSubmitting ? "0%" : "-100%",
        }}
        className="absolute inset-0 flex items-center justify-center"
        aria-hidden={!isSubmitting}
      >
        <Spinner color="#fff" className="mr-4" size="28px" /> Submitting
      </motion.span>
      <motion.span
        className="absolute inset-0 flex items-center justify-center"
        initial={false}
        animate={{
          y: isSubmitting ? "100%" : "0%",
        }}
      >
        {children}
      </motion.span>
      <span aria-hidden>&nbsp;</span>
    </button>
  );
};
